import { BarChart3, Image, Users } from 'lucide-react'
import { Suspense } from 'react'
import { useTranslation } from 'react-i18next'
import { NavLink, Outlet } from 'react-router-dom'

import { cn } from '@/lib/utils'

import { BottomTabBar } from './components/BottomTabBar'
import { TopBar } from './components/TopBar'

const adminNav = [
  { to: '/admin/users', labelKey: 'navigation.user_management', icon: Users },
  { to: '/admin/products', labelKey: 'navigation.product_management', icon: Image },
  { to: '/analytics', labelKey: 'navigation.analytics', icon: BarChart3 },
]

const PageLoading = () => {
  const { t } = useTranslation('common')
  return <div className="p-8 text-sm text-muted-foreground">{t('page_loading')}</div>
}

export const AppLayout = ({ sidebar = false }: { sidebar?: boolean }) => {
  const { t } = useTranslation('common')

  return (
    <div className="flex h-dvh flex-col bg-background">
      <TopBar />
      <div className={cn('min-h-0 flex-1', sidebar && 'lg:grid lg:grid-cols-[200px_1fr]')}>
        {sidebar ? (
          <aside className="hidden border-r border-border bg-card p-3 lg:block">
            <nav className="space-y-1">
              {adminNav.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  className={({ isActive }) =>
                    cn(
                      'flex items-center gap-2 rounded px-3 py-2 text-sm text-muted-foreground',
                      isActive && 'bg-primary-soft text-primary',
                    )
                  }
                >
                  <item.icon className="h-4 w-4" aria-hidden="true" strokeWidth={1.5} />
                  {t(item.labelKey)}
                </NavLink>
              ))}
            </nav>
          </aside>
        ) : null}
        <main className="h-full min-h-0 overflow-y-auto bg-background">
          <Suspense fallback={<PageLoading />}>
            <Outlet />
          </Suspense>
        </main>
      </div>
      <BottomTabBar className="lg:hidden" />
    </div>
  )
}
